import React from "react";

function warningExlamationIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2938_2479)">
        <path
          d="M1.67365 12.9453H12.3255C12.4985 12.9453 12.6686 12.9004 12.819 12.815C12.9695 12.7296 13.0952 12.6066 13.1839 12.458C13.2726 12.3095 13.3213 12.1405 13.3251 11.9675C13.3289 11.7946 13.2879 11.6236 13.2058 11.4712L7.88021 1.58062C7.5024 0.879375 6.49677 0.879375 6.11896 1.58062L0.793337 11.4712C0.711322 11.6236 0.67023 11.7946 0.674075 11.9675C0.677921 12.1405 0.726573 12.3095 0.815277 12.458C0.903981 12.6066 1.0297 12.7296 1.18016 12.815C1.33061 12.9004 1.50065 12.9453 1.67365 12.9453Z"
          stroke="#F44336"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.82043 5.10587L6.99981 8.91837L7.17887 5.10743C7.17998 5.08307 7.1761 5.05874 7.16749 5.03592C7.15887 5.01311 7.14569 4.99229 7.12876 4.97474C7.11182 4.95719 7.09149 4.94328 7.06899 4.93385C7.0465 4.92443 7.02232 4.91969 6.99793 4.91993C6.97397 4.92016 6.9503 4.9252 6.92832 4.93473C6.90634 4.94426 6.88649 4.95811 6.86994 4.97544C6.8534 4.99277 6.84049 5.01324 6.83199 5.03564C6.82348 5.05804 6.81956 5.08192 6.82043 5.10587Z"
          stroke="#F44336"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 11.4141C6.87639 11.4141 6.75555 11.3774 6.65277 11.3087C6.54999 11.2401 6.46988 11.1424 6.42258 11.0282C6.37527 10.914 6.36289 10.7884 6.38701 10.6671C6.41113 10.5459 6.47065 10.4345 6.55806 10.3471C6.64547 10.2597 6.75683 10.2002 6.87807 10.1761C6.99931 10.152 7.12497 10.1643 7.23918 10.2116C7.35338 10.2589 7.45099 10.339 7.51967 10.4418C7.58834 10.5446 7.625 10.6654 7.625 10.7891C7.625 10.9548 7.55915 11.1138 7.44194 11.231C7.32473 11.3482 7.16576 11.4141 7 11.4141Z"
          fill="#F44336"
        />
      </g>
      <defs>
        <clipPath id="clip0_2938_2479">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default warningExlamationIcon;
